import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="container mt-5">
            <h1>Privacy Policy</h1>
            <p><strong>Last Updated:</strong> 21/03/2025</p>
            <p>Welcome to Brain Beat Productions ("we," "our," or "us"). Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal data when you use our WhatsApp message marketing services.</p>
            
            <h2>1. Information We Collect</h2>
            <ul>
                <li><strong>Contact Information:</strong> Name, phone number, and email address.</li>
                <li><strong>Message Data:</strong> WhatsApp message templates, delivery status, and user responses.</li>
                <li><strong>Device Information:</strong> IP address, browser type, and operating system.</li>
                <li><strong>Usage Data:</strong> Interaction with our messages, timestamps, and opt-in/opt-out preferences.</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <ul>
                <li>Sending WhatsApp messages based on user consent.</li>
                <li>Managing subscription preferences (opt-in/opt-out requests).</li>
                <li>Analyzing message delivery and engagement rates.</li>
                <li>Complying with legal and regulatory requirements.</li>
            </ul>

            <h2>3. Data Sharing and Third-Party Services</h2>
            <p>We do not sell or share your personal data with unauthorized third parties. However, we may share data with:</p>
            <ul>
                <li><strong>WhatsApp (Meta Platforms, Inc.):</strong> For message delivery.</li>
                <li><strong>Service Providers:</strong> That help us manage our marketing services.</li>
                <li><strong>Legal Authorities:</strong> If required by law.</li>
            </ul>

            <h2>4. User Rights & Data Control</h2>
            <ul>
                <li><strong>Opt-out:</strong> Reply "STOP" to unsubscribe from our WhatsApp messages.</li>
                <li><strong>Request Data Deletion:</strong> Contact us at [Your Email] to delete your personal data.</li>
                <li><strong>Access Your Data:</strong> Request details about the data we hold about you.</li>
            </ul>

            <h2>5. Data Security</h2>
            <p>We implement industry-standard security measures to protect your data from unauthorized access, modification, or deletion.</p>

            <h2>6. Cookies and Tracking</h2>
            <p>We may use cookies and analytics tools to enhance user experience and monitor the performance of our services.</p>

            <h2>7. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated date.</p>

            <h2>8. Contact Us</h2>
            <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
            <p>
                Brain Beat Productions <br/>
                chintan.shah9389@gmail.com <br/>
                Kandivali West, Mumbai, Maharashtra, INDIA
            </p>
        </div>
    );
};

export default PrivacyPolicy;
